import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { QueryClient } from '@tanstack/react-query';

import { useCurrentPartner } from 'services/repositories/partners/partners';
import { useRelationship } from 'services/repositories/relationships/relationships';
import { routeToPage } from 'support/helpers/navigation/navigation';
import { getTradePartner } from 'support/helpers/relationships/relationships';
import { ConnectionsRoutes, NetworkRoutes } from 'support/types';

type Origin = 'connections' | 'network';

export const legacyRelationshipRedirectLoader =
  (queryClient: QueryClient, origin: Origin) =>
  async ({ params }: LoaderFunctionArgs) => {
    const { relationshipId } = params;
    if (!relationshipId) {
      throw new Response('Not Found', { status: 404 });
    }

    const [currentPartner, relationship] = await Promise.all([
      queryClient.fetchQuery({
        queryKey: useCurrentPartner.getKey(),
        queryFn: useCurrentPartner.queryFn,
      }),
      queryClient.fetchQuery({
        queryKey: useRelationship.getKey({ relationshipId }),
        queryFn: useRelationship.queryFn,
      }),
    ]);

    if (!relationship || !currentPartner) {
      throw new Response('Not Found', { status: 404 });
    }

    const tradePartner = getTradePartner(relationship, currentPartner.id);
    if (!tradePartner?.id) {
      throw new Response('Not Found', { status: 404 });
    }

    const targetRoute =
      origin === 'network' ? NetworkRoutes.relationshipDetails : ConnectionsRoutes.relationshipDetails;

    return redirect(routeToPage(targetRoute, { partnerId: tradePartner.id, relationshipId }));
  };
